import React, { useEffect, useState, useRef } from 'react';
import i18n from '../../../i18n';
import { useFormStatus } from 'react-dom';
import Input from '../../../components/Input';
import baseHelper from '../../../helpers/BaseHelper';
import { useDispatch, useSelector } from 'react-redux';

import authActions from '../../../redux/futures/auth/actions';
import * as authTypes from '../../../redux/futures/auth/types';



const ModalAuthenOTPCode = ({ isShowModal, handleCloseModal, resendOtp2FA, activeAuth, selectedPhone, isVerifyPhone }) => {
  const dispatch = useDispatch();

  const authReducer = useSelector((state) => state.auth);

  const [stepSelected, setStepSelected] = useState(1);

  const [codeAuth, setCodeAuth] = useState(['', '', '', '', '', '']);
  const [customPhone, setCustomPhone] = useState('');
  const [timeLeft, setTimeLeft] = useState(60);
  const [isCountdownActive, setIsCountdownActive] = useState(true);
  const countdownRef = useRef(null);

  const [isPhoneValid, setIsPhoneValid] = useState(false);

  const inputRefs = useRef([
    React.createRef(),
    React.createRef(),
    React.createRef(),
    React.createRef(),
    React.createRef(),
    React.createRef(),
  ]);

  const phoneRef = useRef([]);

  useEffect(() => {
    if (authReducer.action == authTypes.RESEND_OTP_2FA) {
      if (authReducer.status) {
        window.LadiUI.toast('success', '', authReducer.message, 5000, 'top-right');
        setStepSelected(2);
        startCountdown(60);
        let blockCountdown = document.getElementById('block-btn-resend-otp');
        if (blockCountdown) {
          blockCountdown.classList.remove('d-none');
          blockCountdown.classList.add('d-flex');
        }
      } else {
        window.LadiUI.toast('danger', '', authReducer.message, 5000, 'top-right');
      }
    }
  }, [authReducer])

  useEffect(() => {
    if (selectedPhone) {
      setCustomPhone(selectedPhone);
    }
  }, [selectedPhone])

  useEffect(() => {
    // const phone = baseHelper.normalizeVietnamesePhone(customPhone);
    // setCustomPhone(phone);
    setIsPhoneValid(baseHelper.isPhoneVietNam(customPhone));
  }, [customPhone])


  const handleClose = () => {
    if (countdownRef.current) {
      clearInterval(countdownRef.current);
      countdownRef.current = null;
    }
    setCodeAuth(['', '', '', '', '', '']);
    setStepSelected(1);
    setIsCountdownActive(false);
    setTimeLeft(60);

    let blockCountdown = document.getElementById('block-btn-resend-otp');
    if (blockCountdown) {
      blockCountdown.classList.remove('d-flex');
      blockCountdown.classList.add('d-none');
    }

    handleCloseModal();
  };

  const handleBackStep = (value) => {
    setStepSelected(value);

    let blockCountdown = document.getElementById('block-btn-resend-otp');
    if (blockCountdown) {
      blockCountdown.classList.remove('d-flex');
      blockCountdown.classList.add('d-none');
    }
  }

  // Xử lý khi nhập số
  const handleInputCode = (index, e) => {
    const value = e.target.value.replace(/[^0-9]/g, '');
    if (value.length > 1) return;

    const newCode = [...codeAuth];
    newCode[index - 1] = value;
    setCodeAuth(newCode);

    if (value && index < 6) {
      inputRefs.current[index].current.focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === 'Backspace' && !codeAuth[index - 1] && index > 1) {
      inputRefs.current[index - 2].current.focus();
    }
  };

  const handlePaste = (e) => {
    const paste = e.clipboardData.getData('text');
    if (paste.length === 6 && /^\d+$/.test(paste)) {
      const newCode = paste.split('');
      setCodeAuth(newCode);
      inputRefs.current[5].current.focus();
      e.preventDefault();
    }
  };

  const handleConfirmActive = () => {
    let otpCode = codeAuth.join('');
    if (otpCode) {
      activeAuth(otpCode);
    }
    setCodeAuth(['', '', '', '', '', '']);
  }

  const handleSendOTP = () => {
    if (isPhoneValid && customPhone) {
      resendOtp2FA(customPhone)
    }
  }


  const startCountdown = (seconds) => {
    if (countdownRef.current) {
      clearInterval(countdownRef.current);
    }

    setTimeLeft(seconds);
    setIsCountdownActive(true);

    countdownRef.current = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(countdownRef.current);
          countdownRef.current = null;
          setIsCountdownActive(false);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  const handleResendOTP = () => {
    resendOtp2FA(customPhone)
  }

  const onChangeInput = (event) => {
    setCustomPhone(event.target.value);
  }

  console.log('isPhoneValid', typeof isVerifyPhone)
  return (
    <div className={`ladiui modal no-close ${isShowModal ? 'open' : ''}`} id='modal-authen-otp'>
      <div className="ladiui modal-dialog modal-dialog-centered">
        <div className="ladiui modal-content">
          <div className="ladiui modal-header custom-v4">
            <div className="title-description-modal">
              <div className="ladiui title-2 color-900 font-600 text-15">{i18n.t('TWO_FA_AUTH.TITLE_SMS')}</div>
              <p>{i18n.t('TWO_FA_AUTH.DESC_SMS')}</p>
            </div>
            <button
              type="button"
              data-dismiss="modal"
              data-target="modal-authen-otp"
              style={{ "top": "18px", "right": "0px" }}
              className="ladiui modal-close"
              onClick={handleClose}
            >
              <img
                src="https://w.ladicdn.com/ladiui/icons/new-ldicon-close-fill-2.svg"
                className="mr-0"
                alt=""
              />
            </button>
          </div>

          <div className="ladiui modal-body">
            {
              stepSelected === 1
              &&
              <div className='block-step'>
                <div className='title-step'>
                  <span>{i18n.t('TWO_FA_AUTH.STEP_1')}</span>
                  <p>{i18n.t('TWO_FA_AUTH.ENTER_PHONE')}</p>
                </div>
                <div className='ladiui form-group'>
                  <label className='ladiui-label'>{i18n.t('TWO_FA_AUTH.PHONE')}</label>
                  {isVerifyPhone === 'true' ?
                    <input className='ladiui form-control' value={customPhone ? customPhone : ''} placeholder='+84 (xxx) xxx-xxxx' type='number' disabled />
                    :
                    <Input
                      ref={phoneRef.current[0]}
                      name="phone"
                      validationName="Phone"
                      placeholder={i18n.t('PROFILE.PHONE')}
                      value={customPhone}
                      onChange={onChangeInput}
                      validations={{ isRequired: true }}
                    />
                  }
                  <span className='mt-8' style={{ fontSize: '12px', color: '#64748b' }}>{i18n.t('TWO_FA_AUTH.ENTER_PHONE_DESC')}</span>
                </div>
              </div>
            }

            {
              stepSelected === 2
              &&
              <div className='block-step'>
                <div className='title-step'>
                  <span>{i18n.t('TWO_FA_AUTH.STEP_2')}</span>
                  <p>{i18n.t('TWO_FA_AUTH.ENTER_AUTH_CODE')}</p>
                </div>
                <div className='description'>
                  {i18n.t('TWO_FA_AUTH.ENTER_PHONE_DESC_2')} {customPhone ? customPhone : ''}.
                </div>
                <div className='block-enter-authen-code'>
                  <p>{i18n.t('TWO_FA_AUTH.AUTH_CODE')}</p>
                  <div className='code-container' onPaste={handlePaste}>
                    <input type="text" class="code-input" maxlength="1" value={codeAuth[0]} onChange={(e) => handleInputCode(1, e)} ref={inputRefs.current[0]} onKeyDown={(e) => handleKeyDown(1, e)} />
                    <input type="text" class="code-input" maxlength="1" value={codeAuth[1]} onChange={(e) => handleInputCode(2, e)} ref={inputRefs.current[1]} onKeyDown={(e) => handleKeyDown(2, e)} />
                    <input type="text" class="code-input" maxlength="1" value={codeAuth[2]} onChange={(e) => handleInputCode(3, e)} ref={inputRefs.current[2]} onKeyDown={(e) => handleKeyDown(3, e)} />
                    <input type="text" class="code-input" maxlength="1" value={codeAuth[3]} onChange={(e) => handleInputCode(4, e)} ref={inputRefs.current[3]} onKeyDown={(e) => handleKeyDown(4, e)} />
                    <input type="text" class="code-input" maxlength="1" value={codeAuth[4]} onChange={(e) => handleInputCode(5, e)} ref={inputRefs.current[4]} onKeyDown={(e) => handleKeyDown(5, e)} />
                    <input type="text" class="code-input" maxlength="1" value={codeAuth[5]} onChange={(e) => handleInputCode(6, e)} ref={inputRefs.current[5]} onKeyDown={(e) => handleKeyDown(6, e)} />
                  </div>
                </div>
              </div>
            }
          </div>

          <div className="ladiui modal-footer justify-end custom-v4 flex-col gap-16">
            {
              stepSelected === 1
                ?
                <button
                  className={`ladiui btn btn-primary w100 ${!isPhoneValid ? 'disable' : ''}`}
                  onClick={() => handleSendOTP(2)}
                  disabled={!isPhoneValid}
                >
                  {i18n.t('TWO_FA_AUTH.SEND_OTP')}
                </button>
                :
                <div className='flex items-center gap-16 w100'>
                  <button
                    className="ladiui btn btn-secondary w100 mr-0"
                    onClick={() => handleBackStep(1)}
                  >
                    {i18n.t('TWO_FA_AUTH.BACK')}
                  </button>
                  <button
                    className="ladiui btn btn-primary w100"
                    onClick={() => handleConfirmActive()}
                  >
                    {i18n.t('TWO_FA_AUTH.CONFIRM')}
                  </button>
                </div>
            }

            <div className='text-center block-btn-resend-otp d-none' id="block-btn-resend-otp">
              <div className='btn-resend cursor-pointer' id='btn-resend-otp' style={{ display: isCountdownActive ? 'none' : 'block' }} onClick={() => handleResendOTP()}>{i18n.t('TWO_FA_AUTH.RESEND_OTP')}</div>
              <span className='items-center' id="countdown-resend-otp" style={{ display: isCountdownActive ? 'flex' : 'none' }}>{i18n.t('TWO_FA_AUTH.RESEND_OTP_DESC')}&nbsp;<div className='flex items-center' id='timer'>{timeLeft}</div>s</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalAuthenOTPCode;
